import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ScheduleEventPageRoutingModule } from './schedule-event-routing.module';

import { ScheduleEventPage } from './schedule-event.page';
import { OpenFormComponentModule } from 'src/app/component/open-form/open-form.component.module';
import { DxDataGridModule } from 'devextreme-angular';
import { ConfirmBoxDirectiveModule } from 'src/app/directives';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		ScheduleEventPageRoutingModule,
		OpenFormComponentModule,
		DxDataGridModule,
		ConfirmBoxDirectiveModule,
	],
	declarations: [ScheduleEventPage],
})
export class ScheduleEventPageModule {}
